module.exports = __webpack_public_path__ + "static/img/error.16894a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.png
// module id = FF+y
// module chunks = 64